import { render } from "./ModalBookshelfSort.vue?vue&type=template&id=18d9c87e&scoped=true"
import script from "./ModalBookshelfSort.vue?vue&type=script&lang=js"
export * from "./ModalBookshelfSort.vue?vue&type=script&lang=js"

import "./ModalBookshelfSort.vue?vue&type=style&index=0&id=18d9c87e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d9c87e"]])

export default __exports__